"use client"

import * as React from "react"

import { cn } from "../../lib/utils"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "./modal"
import { Button } from "./button"

export interface ConnectPlatformModalProps {
  className?: string
  isOpen: boolean
  onClose?: () => void
  onConnect?: () => void
  avatarSrc?: string
  message?: string
  buttonText?: string
  isLoading?: boolean
}

function ConnectPlatformModal({
  className,
  isOpen,
  onClose,
  onConnect,
  avatarSrc,
  message = "Looks like your LinkedIn doesn't meet the requirement but you can connect another account below.",
  buttonText = "Connect another platform",
  isLoading = false,
}: ConnectPlatformModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={cn("p-6", className)}>
      <ModalHeader>
        {/* Avatar */}
        <div className="w-20 h-20 rounded-full overflow-hidden bg-gray-100 flex items-center justify-center mb-4">
          {avatarSrc ? (
            <img
              src={avatarSrc}
              alt="User avatar"
              className="w-full h-full object-cover"
            />
          ) : (
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40" cy="40" r="40" fill="#F3E8FF" />
              <circle cx="40" cy="32" r="12" fill="#C4B5FD" />
              <path
                d="M20 64C20 52.954 28.954 44 40 44C51.046 44 60 52.954 60 64"
                fill="#C4B5FD"
              />
            </svg>
          )}
        </div>
      </ModalHeader>

      <ModalBody>
        <p className="text-sm text-[#344054] leading-relaxed">{message}</p>
      </ModalBody>

      <ModalFooter>
        <Button
          className="w-full"
          onClick={onConnect}
          disabled={isLoading}
        >
          {isLoading ? "Connecting..." : buttonText}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export { ConnectPlatformModal }
